import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

import { isSysAdmin } from "../loanDetailEditUtil";

import {
  shouldShowWaiverStartDateEdit
  , shouldShowWaiverEndDateEdit
} from "./section-loan-cash-management-row-logic";

export const rows = {
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Cash Management Reporting",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.cashmanagementreporting.header"
      }
    ]
  },
  highPriority: {
    label: "Is this loan in cash management?",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: "covenants.highPriority",
        variant: "filled",
        hideLabel: true
      }
    ]
  },
  reportingWaiver: {
    label: "Reporting Waiver",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: "covenants.reportingWaiver",
        variant: "filled",
        hideLabel: true
      }
    ]
  },
  reportingWaiverStartDate: {
    isVisible: data => shouldShowWaiverStartDateEdit(data),
    label: "Reporting Waiver Start Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "covenants.reportingWaiverStartDate",
        variant: "filled"
      }
    ]
  },
  reportingWaiverEndDate: {
    isVisible: data => shouldShowWaiverEndDateEdit(data),
    label: "Reporting Waiver End Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "covenants.reportingWaiverEndDate",
        variant: "filled"
      }
    ]
  },
  cashManagementReportingMisc: {
    label: "Miscellaneous",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.cashManagementReportingMisc",
        variant: "filled",
        multiline: true
      }
    ]
  }

};
